/**
 * OTA Service
 *
 * Contact: man-team-mdm@man.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SemanticVersion } from '~/api/models/semantic-version';

/**
 * List of individual device statistics for this stage
 */
export interface StageDeviceInfo {
    /**
     * Serial number of the device
     */
    serialNumber?: string;
    /**
     * Type of the device
     */
    deviceType?: StageDeviceInfo.DeviceTypeEnum;
    /**
     * Current installation status of the update
     */
    installationStatus?: StageDeviceInfo.InstallationStatusEnum;
    /**
     * Health status of the device
     */
    status?: string;
    /**
     * Vehicle identification number
     */
    vin?: string;
    /**
     * Order of the stage in the campaign
     */
    stageOrder?: number;
    /**
     * Timestamp of the last check for update request
     */
    lastCheckForUpdateTimestamp?: string;
    lastEssentialImageReported?: any;
    lastBaseSoftwareVersionReported?: SemanticVersion;
    lastDistroVersionReported?: SemanticVersion;
}
export namespace StageDeviceInfo {
    export const DeviceTypeEnum = {
        Tbm3: 'TBM3',
        Vcm: 'VCM',
        Cm4: 'CM4'
    } as const;
    export type DeviceTypeEnum = typeof DeviceTypeEnum[keyof typeof DeviceTypeEnum];
    export const InstallationStatusEnum = {
        NotStarted: 'NOT_STARTED',
        SentToDevice: 'SENT_TO_DEVICE',
        InProgress: 'IN_PROGRESS',
        Updated: 'UPDATED',
        Failed: 'FAILED',
        RebootPending: 'REBOOT_PENDING'
    } as const;
    export type InstallationStatusEnum = typeof InstallationStatusEnum[keyof typeof InstallationStatusEnum];
}


